export default "__VITE_ASSET__9fb9b021__"